import { render, staticRenderFns } from "./UserSurvey.vue?vue&type=template&id=2da92939&"
import script from "./UserSurvey.vue?vue&type=script&lang=js&"
export * from "./UserSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports